import { getWriteAuthHeaders } from './writeAuth';

/**
 * fetch() with Authorization: Bearer from session storage (admin or FD token).
 * Merges any caller-provided headers; does not force Content-Type (callers
 * that POST JSON should set it).
 */
export async function authFetch(url, options = {}) {
  const base = getWriteAuthHeaders();
  const headers = { ...base, ...(options.headers || {}) };
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 30000);
  let res;
  try {
    res = await fetch(url, { credentials: 'include', ...options, headers, signal: controller.signal });
  } catch (err) {
    if (err && err.name === 'AbortError' && typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('modality:fetch-timeout', { detail: { url: String(url) } }));
    }
    throw err;
  } finally {
    clearTimeout(timeoutId);
  }
  try {
    // If a stored JWT is missing/expired, support endpoints will 401. In that
    // case we need to force the front-desk login UI back on-screen so staff
    // can recover without a manual localStorage clear.
    if (res.status === 401 && typeof window !== 'undefined') {
      const u = String(url || '');
      // Login endpoints handle their own error UX; firing the global
      // auth-401 redirect on a wrong-password attempt would yank the
      // user out of the login modal mid-attempt.
      const isLoginCall =
        u.includes('/api/frontdesk-login') ||
        u.includes('/api/admin-login') ||
        (u.includes('/api/inventory') && u.includes('action=login')) ||
        (u.includes('/api/coverage') && u.includes('action=login'));
      if (!isLoginCall) {
        window.dispatchEvent(new CustomEvent('modality:auth-401', { detail: { url: u } }));
      }
    }
  } catch {
    // ignore
  }
  return res;
}
